<template>
    <div class="container">
        <vue-headful
                title="Mamagement Members - SIC Dashboard"
        />
        <div class="row">
            <div class="col-md-12 mt-5 mb-5">
                <div class="card shadow">
                    <div class="card-header border-0">
                        <div class="row align-items-center">
                            <div class="">
                                <router-link :to="{name: 'website-managements-teams-add'}" class="btn my-4 btn-primary">
                                    ADD Management Member
                                </router-link>
                            </div>
                        </div>
                    </div>
                    <div class="table-responsive">
                        <!-- Projects table -->
                        <table class="table align-items-center table-flush">
                            <thead class="thead-light">
                            <tr>
                                <th>Actions</th>
                                <th scope="col">First Name</th>
                                <th scope="col">Last Name</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr v-for="member in MemberDetails" :key="member.id">
                                <td>
                                    <button @click="deleteTeams(member.id)" type="button"
                                            class="btn btn-danger fas fa-trash" data-toggle="tooltip"
                                            data-placement="top" title="Delete Member"></button>
                                    <router-link :to="{name: 'website-managements-teams-update', params: {team_member_id: member.id}}" class="btn btn-info fas fa-pen"
                                            data-toggle="tooltip" data-placement="top" title="Edit Member"></router-link>
                                </td>
                                <td>
                                    {{member.first_name}}
                                </td>
                                <td>
                                    {{member.last_name}}
                                </td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import _ from "lodash";
import axios from "axios";
import vueHeadful from "vue-headful";

export default {
  data() {
    return {
      MemberDetails: {}
    };
  },
  methods: {
    goNew: function() {
      window.location.href = "/dashboard/website/managements-teams/new";
    },
    editTeams: function(team_member_id) {
      window.location.href =
        "/dashboard/website/managements-teams/update/" + team_member_id;
    },
    get_Teams(type) {
      axios({
        url:
          "admin/management/department/" +
          type +
          "?access_token=" +
          localStorage.getItem("access_token"),
        method: "get",
        body: {},
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.MemberDetails = result.data.department.team;
          },
          error => {
            console.log(error.response);
          }
        )
        .catch(e => {
          console.log(e);
        });
    },
    deleteTeams(id) {
      axios({
        method: "delete",
        url: "admin/management/team/delete/" + id,
        data: {
          access_token: localStorage.getItem("access_token")
        },
        headers: {
          "Content-Type": "application/json"
        }
      })
        .then(
          result => {
            this.$swal("Team Member Deleted Successfully", "", "success");
            this.get_Susteams(1);
            result;
          },
          error => {
            this.$swal(
              "Error",
              "There was an error. Please try again",
              "error"
            );
            let errors = error.response.data.error;
            for (let error in errors) {
              this.$noty.error("Error: " + _.startCase(errors[error][0]));
            }
          }
        )
        .catch(e => {
          console.log(e);
        });
    }
  },
  computed: {},
  components: {
    "vue-headful": vueHeadful
  },
  mounted: function() {
    this.get_Teams(1);
  }
};
</script>
<style>
</style>
